/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Beta_NoteInputs */

const da_forside_beta_note = /** @type {(inputs: Forside_Beta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AImforA er i lukket beta. Du kan kun oprette en konto, hvis du er inviteret.`)
};

/** @type {(inputs: Forside_Beta_NoteInputs) => LocalizedString} */
const en_forside_beta_note = da_forside_beta_note;

/**

* @param {Forside_Beta_NoteInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_beta_note = /** @type {((inputs?: Forside_Beta_NoteInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Beta_NoteInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_beta_note(inputs)
	return /** @type {LocalizedString} */ ("AImforA er i lukket beta. Du kan kun oprette en konto, hvis du er inviteret.")
});